/* =============================================================
   LOLE'S — Theme JS
   ============================================================= */

(function(){
  'use strict';

  /* ---------- Helpers ---------- */
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));
  const lockBody = () => document.body.classList.add('no-scroll');
  const unlockBody = () => document.body.classList.remove('no-scroll');

  /* ---------- Hero Carousel ---------- */
  (function(){
    const carousel = $('[data-hero-carousel]');
    if (!carousel) return;
    const slides = $$('[data-hero-slide]', carousel);
    const dots = $$('[data-hero-dot]', carousel);
    if (slides.length === 0) return;

    let idx = 0;
    let timer = null;

    function show(n){
      slides.forEach((s, i) => {
        if (i === n) s.setAttribute('data-active', '');
        else s.removeAttribute('data-active');
      });
      dots.forEach((d, i) => d.classList.toggle('active', i === n));
      idx = n;
    }
    function next(){ show((idx + 1) % slides.length); }
    function prev(){ show((idx - 1 + slides.length) % slides.length); }
    function start(){
      if (slides.length < 2) return;
      stop();
      timer = setInterval(next, 7000);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }

    show(0);
    start();

    $('[data-hero-next]', carousel) && $('[data-hero-next]', carousel).addEventListener('click', () => { next(); start(); });
    $('[data-hero-prev]', carousel) && $('[data-hero-prev]', carousel).addEventListener('click', () => { prev(); start(); });
    dots.forEach(d => d.addEventListener('click', () => {
      show(parseInt(d.dataset.heroDot, 10));
      start();
    }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    // Touch swipe
    let touchStart = 0;
    carousel.addEventListener('touchstart', e => touchStart = e.touches[0].clientX, { passive: true });
    carousel.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - touchStart;
      if (Math.abs(diff) > 50) { diff < 0 ? next() : prev(); start(); }
    }, { passive: true });
  })();

  /* ---------- Rotating Announcement Bar ---------- */
  (function(){
    const bar = $('[data-ann-bar]');
    if (!bar) return;
    const slides = $$('[data-ann-slide]', bar);
    if (slides.length === 0) return;

    let idx = 0;
    let timer = null;

    function show(n){
      slides.forEach((s, i) => s.classList.toggle('active', i === n));
      idx = n;
    }

    function next(){ show((idx + 1) % slides.length); }
    function prev(){ show((idx - 1 + slides.length) % slides.length); }

    function start(){
      if (slides.length < 2) { show(0); return; }
      stop();
      timer = setInterval(next, 5000);
    }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }

    show(0);
    start();

    $('[data-ann-next]', bar) && $('[data-ann-next]', bar).addEventListener('click', () => { next(); start(); });
    $('[data-ann-prev]', bar) && $('[data-ann-prev]', bar).addEventListener('click', () => { prev(); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
  })();

  /* ---------- Scroll reveal ---------- */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        observer.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  $$('.reveal').forEach(el => observer.observe(el));

  /* ---------- Mobile Nav ---------- */
  const mobileNav = $('.mobile-nav');
  const menuToggle = $('.menu-toggle');
  const navClose = $('.mobile-nav__close');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => { mobileNav.classList.add('open'); lockBody(); });
    navClose && navClose.addEventListener('click', () => { mobileNav.classList.remove('open'); unlockBody(); });
  }

  /* ---------- Cart Drawer ---------- */
  const cartDrawer = $('.cart-drawer');
  const drawerOverlay = $('.drawer-overlay');

  const openCart = () => { cartDrawer && cartDrawer.classList.add('open'); drawerOverlay && drawerOverlay.classList.add('open'); lockBody(); };
  const closeCart = () => { cartDrawer && cartDrawer.classList.remove('open'); drawerOverlay && drawerOverlay.classList.remove('open'); unlockBody(); };

  $$('[data-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); openCart(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
  drawerOverlay && drawerOverlay.addEventListener('click', closeCart);

  /* ---------- Cart fetch & render ---------- */
  async function fetchCart(){
    try {
      const r = await fetch('/cart.js');
      return await r.json();
    } catch(e){ return null; }
  }

  function money(cents){
    const v = (cents/100).toFixed(2).replace('.', ',');
    return v + ' TL';
  }

  async function renderCart(){
    const cart = await fetchCart();
    if (!cart) return;
    const itemsEl = $('.cart-drawer__items');
    const totalEl = $('[data-cart-total]');
    const countEls = $$('.cart-count, [data-cart-count]');
    const progressEl = $('[data-cart-progress]');
    const progressMsg = $('[data-cart-progress-msg]');
    const FREE_SHIP = (window.Loles && window.Loles.freeShipThreshold) || 75000; // default 750 TL in cents

    countEls.forEach(el => el.textContent = cart.item_count);

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty"><p>Sepetiniz boş.</p></div>';
      totalEl && (totalEl.textContent = money(0));
      progressMsg && (progressMsg.innerHTML = '');
      progressEl && (progressEl.style.width = '0%');
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-key="${item.key}">
        <a class="cart-item__media" href="${item.url}">
          <img src="${item.featured_image.url}" alt="${item.title}" loading="lazy">
        </a>
        <div>
          <div class="cart-item__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="cart-item__qty">
            <button type="button" data-qty-dec aria-label="Azalt">−</button>
            <input type="text" value="${item.quantity}" readonly>
            <button type="button" data-qty-inc aria-label="Arttır">+</button>
          </div>
          <button type="button" class="cart-item__remove" data-remove>Kaldır</button>
        </div>
        <div class="cart-item__price">${money(item.final_line_price)}</div>
      </div>
    `).join('');

    totalEl && (totalEl.textContent = money(cart.total_price));

    if (progressEl) {
      const pct = Math.min(100, (cart.total_price / FREE_SHIP) * 100);
      progressEl.style.width = pct + '%';
      const remaining = FREE_SHIP - cart.total_price;
      if (progressMsg) {
        progressMsg.innerHTML = remaining > 0
          ? `Ücretsiz kargoya <strong>${money(remaining)}</strong> kaldı`
          : `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="vertical-align:-3px;margin-right:6px"><circle cx="12" cy="12" r="8.5"/><path d="m8.2 12.2 2.6 2.6 5-5.2"/></svg><strong>Ücretsiz kargo</strong> kazandınız`;
      }
    }

    bindCartItemEvents();
  }

  function bindCartItemEvents(){
    $$('.cart-item').forEach(row => {
      const key = row.dataset.key;
      const inc = row.querySelector('[data-qty-inc]');
      const dec = row.querySelector('[data-qty-dec]');
      const remove = row.querySelector('[data-remove]');
      const qty = parseInt(row.querySelector('input').value, 10);
      inc && inc.addEventListener('click', () => updateItem(key, qty + 1));
      dec && dec.addEventListener('click', () => updateItem(key, Math.max(0, qty - 1)));
      remove && remove.addEventListener('click', () => updateItem(key, 0));
    });
  }

  async function updateItem(key, quantity){
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ id: key, quantity })
      });
      await renderCart();
    } catch(e){ console.error(e); }
  }

  /* ---------- Add to cart (forms + quick-add) ---------- */
  async function addToCart(formOrData){
    let body;
    if (formOrData instanceof HTMLFormElement) {
      body = new FormData(formOrData);
    } else {
      body = new FormData();
      Object.keys(formOrData).forEach(k => body.append(k, formOrData[k]));
    }
    const r = await fetch('/cart/add.js', { method: 'POST', body });
    if (!r.ok) throw new Error('Add to cart failed');
    return r.json();
  }

  // Bind PDP forms
  $$('form[data-pdp-form], form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const orig = btn ? btn.textContent : '';
      btn && (btn.textContent = 'Ekleniyor…');
      try {
        await addToCart(form);
        await renderCart();
        openCart();
      } catch(err){
        alert('Ürün eklenemedi. Lütfen tekrar deneyin.');
      } finally {
        btn && (btn.textContent = orig);
      }
    });
  });

  // Quick-add buttons
  $$('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const id = btn.dataset.quickAdd;
      if (!id) return;
      const orig = btn.textContent;
      btn.textContent = 'Ekleniyor…';
      try {
        await addToCart({ id, quantity: 1 });
        await renderCart();
        openCart();
      } catch(err){
        alert('Eklenemedi.');
      } finally {
        btn.textContent = orig;
      }
    });
  });

  /* ---------- PDP Variant Picker ---------- */
  $$('.variant-picker').forEach(picker => {
    const inputs = picker.querySelectorAll('input[type="radio"]');
    inputs.forEach(inp => {
      inp.addEventListener('change', () => {
        // Update label active states
        picker.querySelectorAll('label').forEach(l => l.classList.remove('active'));
        inp.closest('label').classList.add('active');
        // Update master variant id
        updateMasterVariant();
      });
    });
  });

  function updateMasterVariant(){
    const form = $('form[data-pdp-form]');
    if (!form) return;
    const selected = $$('.variant-picker input:checked', form).map(i => i.value);
    if (!window.Loles || !window.Loles.variants) return;
    const match = window.Loles.variants.find(v => {
      return selected.every(opt => v.options.includes(opt));
    });
    if (match) {
      const masterInput = form.querySelector('input[name="id"]');
      masterInput && (masterInput.value = match.id);
      const priceEl = $('.pdp__price');
      if (priceEl && match.price) priceEl.textContent = money(match.price);
      const submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Sepete Ekle' : 'Tükendi';
      }
    }
  }

  /* ---------- PDP Gallery ---------- */
  const thumbs = $$('.pdp__gallery-thumbs button');
  const mainImg = $('.pdp__gallery-main img');
  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const src = t.querySelector('img').dataset.full || t.querySelector('img').src;
      if (mainImg) mainImg.src = src;
    });
  });

  /* ---------- Popup Discount ---------- */
  const popup = $('.popup-overlay');
  if (popup) {
    const dismissed = localStorage.getItem('loles_popup_dismissed');
    if (!dismissed) {
      setTimeout(() => popup.classList.add('open'), 4000);
    }
    $$('[data-popup-close]', popup).forEach(b => b.addEventListener('click', () => {
      popup.classList.remove('open');
      localStorage.setItem('loles_popup_dismissed', Date.now());
    }));
    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.classList.remove('open');
        localStorage.setItem('loles_popup_dismissed', Date.now());
      }
    });
  }

  /* ---------- Subscribe & Save toggle ---------- */
  $$('.subscribe-toggle input[type="radio"]').forEach(inp => {
    inp.addEventListener('change', () => {
      const form = inp.closest('form');
      if (!form) return;
      const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
      if (inp.value === 'one-time') {
        sellingPlanInput && sellingPlanInput.remove();
      } else if (inp.dataset.sellingPlan) {
        let sp = form.querySelector('input[name="selling_plan"]');
        if (!sp) {
          sp = document.createElement('input');
          sp.type = 'hidden';
          sp.name = 'selling_plan';
          form.appendChild(sp);
        }
        sp.value = inp.dataset.sellingPlan;
      }
    });
  });

/* ---------- Quick-add visual feedback ---------- */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    btn.classList.add('added');
    setTimeout(function() { btn.classList.remove('added'); }, 600);
  });

  /* ---------- Cart recommendations (Shopify ML API) ---------- */
  function formatMoneyTL(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  async function renderCartRecommendations() {
    var container = document.querySelector('[data-cart-recs]');
    if (!container) return;

    try {
      // 1) Get current cart
      var cartRes = await fetch('/cart.js');
      var cart = await cartRes.json();

      // 2) Pick a product to base recommendations on
      //    If cart has items, use the most recent. If empty, hide recs.
      if (!cart.items || cart.items.length === 0) {
        container.innerHTML = '';
        return;
      }

      var baseProductId = cart.items[cart.items.length - 1].product_id;

      // 3) Fetch Shopify's ML recommendations
      var recRes = await fetch('/recommendations/products.json?product_id=' + baseProductId + '&limit=8&intent=related');
      var recData = await recRes.json();
      var products = recData.products || [];

      // 4) Filter out products already in cart
      var inCartIds = {};
      cart.items.forEach(function(i) { inCartIds[i.product_id] = true; });
      products = products.filter(function(p) { return !inCartIds[p.id] && p.available; });

      if (products.length === 0) {
        container.innerHTML = '';
        return;
      }

      // 5) Render cards
      var cards = products.map(function(p) {
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
        var imgSrc = p.featured_image || (p.images && p.images[0]) || '';
        var title = p.title.length > 32 ? p.title.substring(0, 32) + '…' : p.title;
        return (
          '<div class="cart-addon__card">' +
            '<a href="' + p.url + '" class="cart-addon__media">' +
              '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" width="80" height="80">' +
            '</a>' +
            '<div class="cart-addon__body">' +
              '<a href="' + p.url + '" class="cart-addon__name">' + title + '</a>' +
              '<div class="cart-addon__price-row">' +
                '<span class="cart-addon__price">' + formatMoneyTL(p.price) + '</span>' +
                '<button type="button" class="cart-addon__add" data-quick-add="' + variantId + '" aria-label="' + p.title + ' sepete ekle">' +
                  '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="8" y1="2" x2="8" y2="14"/><line x1="2" y1="8" x2="14" y2="8"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      container.innerHTML =
        '<div class="cart-addon">' +
          '<div class="cart-addon__head">' +
            '<h4 class="cart-addon__title">Bunları da Beğenebilirsin</h4>' +
            '<span class="cart-addon__sub">Müşteri favorileri</span>' +
          '</div>' +
          '<div class="cart-addon__row">' + cards + '</div>' +
        '</div>';
    } catch (err) {
      console.warn('Cart recommendations failed:', err);
      container.innerHTML = '';
    }
  }

  // Hook 1: When cart drawer opens
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-cart-open]')) {
      setTimeout(renderCartRecommendations, 150);
    }
  });

  // Hook 2: After any quick-add completes (small delay for cart to update)
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-quick-add]')) {
      setTimeout(renderCartRecommendations, 700);
    }
  });

  // Hook 3: After any standard add-to-cart form submission
  document.addEventListener('submit', function(e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      setTimeout(renderCartRecommendations, 700);
    }
  });

  // Hook 4: Initial page load
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(renderCartRecommendations, 400);
  });
  
  /* ---------- Init cart on load ---------- */
  document.addEventListener('DOMContentLoaded', renderCart);

  // Expose for inline onclick if needed
  window.LolesTheme = { openCart, closeCart, renderCart };
/* ---------- Force autoplay all reel videos ---------- */
  function playAllReels(){
    $$('.reels__item video, .ugc__item video').forEach(v => {
      v.muted = true;
      v.play().catch(()=>{});
    });
  }
  document.addEventListener('DOMContentLoaded', () => setTimeout(playAllReels, 800));
  window.addEventListener('scroll', function reelScroll(){
    playAllReels();
    window.removeEventListener('scroll', reelScroll);
  }, { once: true });
})();
